import React, { FC, memo, useMemo } from "react";
import { LayoutChangeEvent } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { PayButton, Section } from "@lookiero/payments-front";
import { Text } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Footer } from "../Footer";
import { style as checkoutFooterStyle } from "./CheckoutFooter.style";

interface CheckoutFooterProps {
  readonly isCtaDisabled: boolean;
  readonly onPressCheckout: () => void;
  readonly onLayout?: (event: LayoutChangeEvent) => void;
}

const CheckoutFooter: FC<CheckoutFooterProps> = ({ isCtaDisabled, onPressCheckout, onLayout }) => {
  const basketInfoFreeShippingAndReturnText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.BASKET_INFO_FREE_SHIPPING_AND_RETURN,
  });
  const style = useMemo(() => checkoutFooterStyle(), []);

  return (
    <Footer onLayout={onLayout}>
      <Text level={3} style={style.text} variant="detail">
        {basketInfoFreeShippingAndReturnText}
      </Text>

      <PayButton
        disabled={isCtaDisabled}
        section={Section.DIRECT_BUY_CHECKOUT}
        testID="checkout-button"
        small
        onPress={onPressCheckout}
      />
    </Footer>
  );
};

const MemoizedCheckoutFooter = memo(CheckoutFooter);

export { MemoizedCheckoutFooter as CheckoutFooter };
